import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const TITLE_MAP = {
  '/': '用户中心',
  '/time': '时间统计',
  '/time/report': '报告详情',
  '/bill': '剑飞记账',
  '/write': '语写',
  '/write-article': '我的文章',
  '/write-read': '阅读',
  '/write-live': '人生规划',
  '/write-live100': '人生百年',
  '/write-publish': '剑飞出书',
  '/ai-chat': 'AI 对话',
  '/shenji': '神技科技',
  '/shenji.html': '神技科技',
  '/login': '登录',
};

function getTitle(pathname) {
  // 优先精确匹配
  if (TITLE_MAP[pathname]) return TITLE_MAP[pathname];
  // 然后前缀匹配
  for (const route of Object.keys(TITLE_MAP).sort((a, b) => b.length - a.length)) {
    if (pathname.startsWith(route) && route !== '/') {
      return TITLE_MAP[route];
    }
  }
  return '神技科技';
}

function DocumentTitle({ location }) {
  useEffect(() => {
    const title = getTitle(location.pathname);
    const CONFIG = require('../config').default;
    const suffix = CONFIG.DEV_MODE ? ' · localhost' : ` · ${window.location.hostname || 'i.yuxie.vip'}`;
    document.title = title + suffix;
  }, [location.pathname]);

  return null;
}

export default withRouter(DocumentTitle);
